// extracted by css-extract-rspack-plugin
var _1 = "i2";
export { _1 as "discountsPanelComponent" }
